
import { Vue, Component, Prop } from "vue-property-decorator";
import BuildingIcon from "./BuildingIcon.vue";
import { ProfileResponse } from "../../Models/ProfileResponse";
import router from "@/router";
import axios, { AxiosResponse } from "axios";
import { apiURL, domainSuffix } from "@/App.vue";
import { CreationResponse } from "../../Models/CreationResponse";
import ResponseModal from "@/components/Initial/ResponseModal.vue";
import { Branding } from "@/helper";

@Component({
  components: {
    BuildingIcon,
    ResponseModal,
  },
})
export default class ProfileBuild extends Vue {
  @Prop({ required: false })
  public profileResponse!: string;
  public progress: number = 0;
  public profileCreateResponse: CreationResponse | null = null;
  public pollingURLParam: string | undefined;
  public system: string | undefined;

  public get branding() {
    return Branding.getBranding();
  }

  public get parsedProfileResponse() {
    return this.profileResponse
      ? (JSON.parse(this.profileResponse) as ProfileResponse)
      : undefined;
  }

  public get creationResponse() {
    const resp = this.parsedProfileResponse as CreationResponse | undefined;
    if (!resp || !resp.Type) {
      return undefined;
    }

    return resp;
  }

  public get isAccessTrial() {
    return (
      this.creationResponse &&
      this.creationResponse.Type === "AccessTrialProvisioningStarted"
    );
  }

  public get nonStandardPollingUrl() {
    return (
      (this.creationResponse && this.creationResponse.StatusUrl) ||
      this.pollingURLParam
    );
  }

  public getPollingPromise(profileData: ProfileResponse | undefined) {
    return this.nonStandardPollingUrl
      ? axios.get(this.nonStandardPollingUrl)
      : axios.get(apiURL() + "/api/Signup/CheckProfileReady", {
          params: {
            profileid: profileData!.ProfileId,
          },
        });
  }

  public processSuccess(profileData: ProfileResponse | undefined, data: any) {
    this.progress = 100;
    const redirect = this.getRedirectURL(profileData, data);
    window.setTimeout(() => {
      if (this.nonStandardPollingUrl) {
        window.location.href = redirect;
      } else {
        window.location.replace(redirect);
      }
    }, 500);
  }

  public getRedirectURL(profileData: ProfileResponse | undefined, data: any) {
    if (this.nonStandardPollingUrl) {
      return data.target;
    }

    return (
      "https://authorisation.prospect365" +
      domainSuffix() +
      ".com/api/signup/login/" +
      profileData!.LoginToken
    );
  }

  public isPollingFinished(data: any) {
    if (!this.nonStandardPollingUrl) {
      return !!data;
    }

    return data && data.type === "AccountCreated";
  }

  public async created() {
    if (this.$route.query) {
      this.pollingURLParam = this.$route.query.pollingURL as string;
      this.system = this.$route.query.source as string;
    }
    const check = () => {
      if (this.progress < 90) {
        this.progress += 10;
      }
      const profileData = this.parsedProfileResponse;
      this.getPollingPromise(profileData)
        .then((response) => {
          if (this.isPollingFinished(response.data)) {
            this.processSuccess(profileData, response.data);
          } else {
            window.setTimeout(check, 1000);
          }
        })
        .catch((error) => {
          this.profileCreateResponse = {
            Type: "ProfileCreationError",
          } as CreationResponse;
        });
    };

    window.setTimeout(check, 1000);
  }
}
